
    export const getPetungTetanen = () => null;
    export default {};
  